module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAABOCAYAAAAKLMczAAAAGklEQVQoU2NkgAJGEH3x4sX/o4zRQBgqKQEAb04JqCK/izUAAAAASUVORK5CYII="